import {
  issueOralExamJoinToken,
  issueOralExamLecturerJoinToken,
} from '@/common/api/endpoints/oral-exams/oral-exams';
import type { OralExamTokenResponse } from '@/common/api/models/oralExamTokenResponse';
import type { LiveKitJoinHandle } from '@/student/module/hooks/useEventTaskSlots';
import type { OralExamRouteIds } from '@/common/hooks/oralExam/useOralExamRunStatePoll';
import { unwrapApiResponseData } from '@/common/utils/apiErrorReporter';

/** Lazy LiveKit token handle for a booking (shared by student and lecturer UIs). */
export function createLiveKitJoinHandle(ids: OralExamRouteIds): LiveKitJoinHandle {
  const {
    courseId, moduleId, taskId, bookingId,
  } = ids;
  return {
    provider: 'livekit',
    bookingId,
    requestToken: async (): Promise<OralExamTokenResponse> => {
      const res = await issueOralExamJoinToken(courseId, moduleId, taskId, bookingId);
      return unwrapApiResponseData(res);
    },
  };
}

/** Stable cache key for join-token persistence across component remounts. */
export function getLiveKitJoinCacheKey(handle: LiveKitJoinHandle): string | null {
  if (handle.bookingId) return `booking:${handle.bookingId}`;
  if (handle.slotId) return `slot:${handle.slotId}`;
  return null;
}

/** Lazy LiveKit token handle for a slot (lecturer join without a booking). */
export function createLiveKitSlotJoinHandle(slotId: string): LiveKitJoinHandle {
  return {
    provider: 'livekit',
    slotId,
    requestToken: async (): Promise<OralExamTokenResponse> => {
      const res = await issueOralExamLecturerJoinToken(slotId);
      return unwrapApiResponseData(res);
    },
  };
}
